export default __webpack_public_path__ + "static/media/newspinner.dfc60a73.gif";